import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=2e025f54&scoped=true"
import script from "./SlideProduct.vue?vue&type=script&lang=js"
export * from "./SlideProduct.vue?vue&type=script&lang=js"
import style0 from "./SlideProduct.vue?vue&type=style&index=0&id=2e025f54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e025f54",
  null
  
)

export default component.exports